<template>
    <div class="plugin__content main-stage__content container-fluid">
      <GridPlaylistShow 
        v-bind:video-assets="videoAssets"
        v-bind:selected-video-asset="selectedVideoAsset"
        v-bind:player-visible="playerVisible"
      >
      </GridPlaylistShow>
    </div>  
</template>

<script>
  import GridPlaylistShow from './GridPlaylistShow.vue'
  import axios from 'axios'
  import { EventBus } from '../EventBus.js'
  var themes = ['fantasy', 'forest', 'sea', 'city']
  export default {
    components: {
      GridPlaylistShow
    },

    props: {
      videoPlaylistt: {
        type: Object,
        required: true,
      },
      event: {
        type: Object,
        required: true,
      },      
      eventAttendee: {
        type: Object,
        required: true,        
      }
    },
    
    data: function () {
      return {
        videoPlaylist: {
          video_assets: {
            data: []
          },
        },
        selectedVideoAsset: false,
        playerVisible: false,
        newVideoClicks: 1,
      }
    },

    computed: {

      nextTheme: function () {
        return themes[this.newVideoClicks % themes.length]
      },

      videoPlayerKey () {
        return `video-player-key-${this.newVideoClicks}`
      },

      videoAssets () {
        return this.videoPlaylist.video_assets.data.map((videoPlaylistVideoAsset) => {
          var video_playlist_video_asset_id = videoPlaylistVideoAsset.id
          var { display_order, video_asset } = videoPlaylistVideoAsset
          var gif = this.getGif(video_asset)
          var poster = this.getPoster(video_asset)
          var duration_readable = this.getDurationReadable(video_asset)
          return Object.assign({}, video_asset, {
            video_playlist_video_asset_id,
            display_order,
            poster, 
            gif,
            duration_readable
          })
        })
      },

      selectableVideoAssets () {
        return this.videoAssets.filter(videoAsset => {
          return videoAsset.video_asset_id !== this.selectedVideo.video_asset_id
        })
      }

    },

   

    methods: {

      fetchVideoPlaylist () {
        var url = `/api/v1/video-playlists/${this.videoPlaylistt.id}`
        axios.get(url)
          .then(response => {
            this.videoPlaylist = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },

      selectVideoAsset (videoAsset) {
        this.newVideoClicks = this.newVideoClicks + 1
        this.selectedVideoAsset = false
        this.$nextTick(() => {
          console.log('in next tick', videoAsset)
          this.selectedVideoAsset = videoAsset
          this.playerVisible = true
          window.scrollTo(0, 0)
        }, 1)
      },

      getPlaybackId (videoAsset) {
        var playbackIds =  videoAsset.mux_asset && videoAsset.mux_asset.playback_ids
        if (!playbackIds) return false;
        var parsed = JSON.parse(playbackIds)
        if (!parsed || !parsed.length) return false;
        return parsed[0] && parsed[0].id
      },

      getPoster (videoAsset) {
        var playbackId = this.getPlaybackId(videoAsset)
        if (!playbackId) return false;
        return `https://image.mux.com/${playbackId}/thumbnail.png`
      },

      getDurationReadable (videoAsset) {
        var duration = videoAsset.mux_asset && videoAsset.mux_asset.duration
        if (!duration) return false;
        var date = new Date(null);
        date.setSeconds(duration);
        return date.toISOString().substr(11, 8);
      },

      getGif (videoAsset) {
        var playbackId = this.getPlaybackId(videoAsset)
        if (!playbackId) return false;
        return `https://image.mux.com/${playbackId}/animated.gif`
      },
    },

    mounted () {
      EventBus.$on('video-asset-selected', this.selectVideoAsset.bind(this))
    }
  };
</script>

<style scoped>
  .video-playlist-attendee-show {
    height: 100vh;
    margin: 2rem;
    /* background-color: aliceblue; */
  }

  .video-player-container {
    /* background-color: aqua; */
    height: 100vh;
  }

  .video-playlist-container {
    width: 100%;
    height: 100vh;
    /* background-color: aquamarine; */
  }

  .video-card {
    background: #ffffff;
    box-shadow: 2px 2px 20px 0px rgb(191 197 210);
    padding: 1rem;
    margin: 0.3rem;
    display: flex;
    flex-direction: column;
  }

  .video-card:hover {
    cursor: pointer;
  }

  .row {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
  }
  .row > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }  

</style>
